export const HotelChildRoutes = [
  {
    path: ':contact/:slug',
    name: 'urlaub',
    component: () =>
      import(
        /* webpackChunkName: "hotel" */ '@/modules/hoteldisplay/_views/Offer.vue'
      ),
  },
  {
    path: 'karte',
    name: 'hotel-map',
    component: () =>
      import(
        /* webpackChunkName: "hotel" */ '@/modules/hoteldisplay/_views/Map.vue'
      ),
  },
  {
    path: ':contact',
    name: 'hotel-overview',
    component: () =>
      import(
        /* webpackChunkName: "hotel" */ '@/modules/hoteldisplay/_views/Hotel.vue'
      ),
  },
]
